import {createApp} from 'vue';
import App from './App.vue';
import store from './store';

import ElementPlus from 'element-plus';
import router from './router';
import axios from 'axios';

import 'element-plus/dist/index.css'

// Import Global Components
import TextInput from "@/components/common/input/TextInput";
import Shipments from "@/components/shipments/Shipments";

import authorizeLogin from "@/classes/login/AuthorizeLogin";

import { ApplicationInsights } from '@microsoft/applicationinsights-web'

axios.defaults.baseURL = process.env.VUE_APP_SERVICE_BASE_URL;

const app = createApp(App).use(store).use(ElementPlus).use(router);

// Register Global Components (Can be chained)
app.component('TextInput', TextInput)
    .component('Shipments', Shipments)

let owner = new URL(window.location.origin.toString()).hostname;

store.state.owner = owner.split('.')[0];

if(process.env.VUE_APP_ENV === 'production' || process.env.VUE_APP_ENV === 'devsecure' || process.env.VUE_APP_ENV === 'test') {

    authorizeLogin.authenticate(app, axios);

    const appInsights = new ApplicationInsights({ config: {
            connectionString: 'InstrumentationKey=3d90a559-846e-40bf-83c6-a214ab0274de;IngestionEndpoint=https://uksouth-1.in.applicationinsights.azure.com/;LiveEndpoint=https://uksouth.livediagnostics.monitor.azure.com/;ApplicationId=0200f38a-0ac6-4640-9c37-5e5a5d9aac4d',
            /* ...Other Configuration Options... */
            loggingLevelConsole: 2,

        } });

    appInsights.loadAppInsights(false);
    appInsights.trackPageView();
    

} else {

    authorizeLogin.getUserInfo(app, axios, store.state.tempSecurityId);
}



